module.exports = __webpack_public_path__ + "static/media/ic_check_red.4feba5dc.svg";